export default {
  /**
   * 脱敏公用
   * @param str 脱敏字符串
   * @param begin 起始保留长度，从0开始
   * @param end 结束保留长度，到str.length结束
   * @returns {string}
   */
  desensitizedCommon(str, begin, end) {
    if (!str && begin + end >= str.length) {
      return ''
    }

    const leftStr = str.substring(0, begin)
    const rightStr = str.substring(str.length - end, str.length)

    let strCon = ''
    for (let i = 0; i < str.length - end - begin; i++) {
      strCon += '*'
    }
    return leftStr + strCon + rightStr
  },
  /**
   * 姓名脱敏
   * @param name 脱敏字符串
   * @returns {string}
   */
  name: (name) => {
    if (!name) {
      return '无'
    }
    // 两个字的姓名，隐藏第一个字
    if (name.length === 2) {
      return name.replace(/^./, '*')
    }
    // 三个字的姓名，隐藏第一个字
    if (name.length === 3) {
      return name.replace(/^./, '*')
    }
    // 六个字以下，三个字以上，只显示最后两个字
    if (name.length <= 6 && name.length >= 3) {
      return name.replace(name.substr(0, name.length - 2), '***')
    }
    // 六个字以上，只显示第一个字和最后一个字
    if (name.length > 6) {
      return name.replace(/^(.).*(.)$/, '$1*****$2')
    }
  },
  /**
   * 证件脱敏(身份证号,军官证号,护照号)
   * @param IdNumber 脱敏字符串
   * @returns {string}
   */
  IdNumber: (IdNumber) => {
    if (!IdNumber) {
      return '无'
    }
    // 身份证号
    if (IdNumber.length === 18) {
      return IdNumber.replace(/^(.).*(.)$/, '$1***********$2')
    }
    // 军官证号
    if (IdNumber.length === 10) {
      return IdNumber.replace(/^(.).*(.)$/, '$1********$2')
    }
    // 护照号
    if (IdNumber.length === 9) {
      return IdNumber.replace(/^(.).*(.)$/, '$1********$2')
    }
  },
  /**
   * 手机号脱敏
   * @param card 脱敏字符串
   * @returns {string}
   * 显示前1/3，后1/3，其他用*代替，内容长度不能被三整除时，显示length/3+1和length/3
   */

  card: (card) => {
    if (!card) {
      return '无'
    }
    if (card.length % 3 === 0) {
      return card.replace(/^(.).*(.)$/, '$1$1$1$1*****$2$2$2')
    }
    return card.replace(/^(.).*(.)$/, '$1$1$1******$2$2$2')
  },
  /**
   * 手机号脱敏
   * @param phone 脱敏字符串
   * @returns {string}
   */
  phone: (phone) => {
    if (!phone) {
      return '无'
    }
    // 大陆：前三位，后两位，其他用*代替
    if (phone.length === 11) {
      return `${phone.substring(0, 3)}****${phone.substring(9, 11)}`
    }
    // 香港，澳门：前2位，后2位，其他用*代替
    if (phone.length === 8) {
      return `${phone.substring(0, 2)}****${phone.substring(6, 8)}`
    }
    // 台湾：前2位，后3位，其他用*代替
    if (phone.length === 9) {
      return `${phone.substring(0, 2)}****${phone.substring(6, 9)}`
    }
    // 其他海外地区：前3位，后4位，其他用*代替

    return `${phone.substring(0, 3)}****${phone.substring(8, 11)}`
  },
  /**
   * 手机号脱敏
   * @param iphone 脱敏字符串
   * @returns {string}
   * 固定电话，显示区号和后四位，其他用*代替
   */

  iphone: (iphone) => {
    if (!iphone) {
      return '无'
    }
    return `${iphone.substring(0, 3)}****${iphone.substring(6, 11)}`
  },
  /**
   * 邮箱脱敏
   * @param email 脱敏字符串
   * @returns {string}
   * 邮箱脱敏,@前面显示第3位，3位后显示3个*，@后面完整显示。如：148***@163.com
   */
  email: (email) => {
    if (!email) {
      return '无'
    }
    return `${email.substr(0, 3)}****${email.substr(email.indexOf('@'))}`
  },
  /**
   * 地址脱敏
   * @param address 脱敏字符串
   * @returns {string}
   */
  address: (address) => {
    if (!address) {
      return '无'
    }
    return `${address.substr(0, address.indexOf('区') + 1)}****`
  },
  /**
   * 昵称脱敏
   * @param nickname 脱敏字符串
   * @returns {string}
   * 显示首字母和最后一个字母，其他用*代替，如：张***疯
   */

  nickname: (nickname) => {
    if (!nickname) {
      return '无'
    }
    return nickname.replace(/^(.).*(.)$/, '$1*****$2')
  },
  /**
   *车辆信息脱敏
   * @param name 脱敏字符串
   * @returns {string}
   * 车辆信息脱敏，车牌号前面的前两位，后面的后两位，其他用*代替，如：粤****7
   */
  carNumber: (carNumber) => {
    if (!carNumber) {
      return '无'
    }
    return carNumber.replace(/^(.).*(.)$/, '$1*****$2')
  },
  /**
   *支付宝、微信号、QQ号脱敏，
   * @param alipay 脱敏字符串
   * @returns {string}
   * 只展示后四位,如：*******1234
   */
  alipay: (alipay) => {
    if (!alipay) {
      return '无'
    }
    return alipay.replace(/.(?=.{4})/g, '*')
  },
  // 获取cookie
  getCookie: (name) => {
    const cookies = document.cookie.split(';').map((cookie) => cookie.trim())
    const cookie = cookies.find((cookie) => cookie.startsWith(`${name}=`))
    return cookie ? cookie.split('=')[1] : null
  },

  // 计算上级区划
  getParentDistricts(districtId) {
    const disArr = districtId.match(/\d{2}/g).filter((item) => item !== '00')
    const areaList = disArr.map((_, index) =>
      disArr
        .slice(0, index + 1)
        .join('')
        .padEnd(12, '0')
    )
    return areaList
  }
}

// 大家根据实际情况修改
